/**
 * Hypercore imports random-access-file so that `Hypercore.defaultStorage`
 * can handle a directory path. The browser build always hands it a
 * random-access-idb factory instead, so this path is unreachable — but the
 * import still has to resolve.
 */
class RandomAccessFileStub {
  constructor () {
    throw new Error('random-access-file is not available in the browser; use random-access-idb')
  }

  static createPool () {
    return null
  }
}

export default RandomAccessFileStub
